import { FooterDataDTO } from "./FooterDataDTO";
import { LanguageDTO } from "./LanguageDTO";
import { UserCustomFieldDTO } from "./UserCustomFieldDTO";

export class SubscriptionSettingsDTO {
    certificateSignatureUrl: string;
    privacyPolicyUrl: string;
    termsOfUseUrl: string;
    termsOfPurchaseUrl: string;
    userCustomFields: UserCustomFieldDTO[];
    footerData: FooterDataDTO;
    defaultLanguage: LanguageDTO | null;

    constructor(obj?) {
        obj = obj || {};

        this.certificateSignatureUrl = obj.certificateSignatureUrl || null;
        this.privacyPolicyUrl = obj.privacyPolicyUrl || null;
        this.termsOfUseUrl = obj.termsOfUseUrl || null;
        this.termsOfPurchaseUrl = obj.termsOfPurchaseUrl || null;
        this.userCustomFields = obj.userCustomFields || [];
        this.footerData = new FooterDataDTO(obj.footerData);
        this.defaultLanguage = obj.defaultLanguage || null;
    }
}
